export default "__VITE_ASSET__gIDTCtYp__"